<div class="modal-header">
    <h4>Load Template Project</h4>

</div>

<div class="modal-body">
    <div *ngIf="!hasData">
        <div class="alert alert-secondary">Loading...</div>
    </div>
    <div class="container" *ngIf="hasData">
        <div>
            <input
                type="search"
                [(ngModel)]="searchTerm"
                class="form-control"
                placeholder="Search..."
                autofocus
                title="Search in template name, ship name and voyage number"
                style="margin-bottom:10px;"
            />
        </div>

        <table class="table table-striped">
            <colgroup>
                <col style="width: auto" />
                <col style="width: 60px" />
                <col style="width: 60px" />
            </colgroup>
            <thead>
                <tr>
                    <th scope="col">Template Name</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let project of currentPage">
                    <td>
                        {{ project.name }}
                    </td>
                    <td>
                        <button
                            class="btn btn-primary btn-sm"
                            (click)="load(project.id)"
                        >
                            Load
                        </button>
                    </td>
                    <td>
                        <button
                            class="btn btn-outline-danger btn-sm"
                            (click)="delete(project)"
                        >
                            Delete
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<div class="modal-footer">
    <div *ngIf="isPageChangerVisible" class="btn-group" role="group">
        <button
            type="button"
            [disabled]="!isPreviousPageEnabled"
            class="btn btn-secondary"
            (click)="previousPage()"
        >
            Previous page
        </button>
        <button
            type="button"
            class="btn btn-secondary"
            [disabled]="!isNextPageEnabled"
            (click)="nextPage()"
        >
            Next page
        </button>
    </div>
    <div class="btn-group">
        <button class="btn btn-secondary" (click)="cancel()">Cancel</button>
    </div>
</div>
